<template>
    <table class="table table-hover bg-alt-yellow rounded my-3">
        <thead>
            <tr>
                <th scope="col">Item</th>
                <th>Price</th>
                <th>Actions</th>
            </tr>
        </thead>
            <tbody>
                <tr v-for="event in events">
                    <th scope="row"><span>{{ event.name }}</span></th>
                    <th><span>£{{ event.price }}</span></th>
                    <td>
                        <button class="btn btn-warning" type="button"><a :href="`/admin/item/edit/${ event.id }`">Edit</a></button>
                        <button class="btn btn-warning mx-2" @click="this.Delete(event.id)" v-if="this.filter =='active'" type="button">Delete</button>
                        <button class="btn btn-warning mx-2" @click="this.Restore(event.id)" v-if="this.filter == 'deleted'" type="button">Restore</button>
                    </td>
                </tr>
          </tbody>
    </table>
</template>

<script>

export default {

    data () {
        return {
            events: []
        }
    },

    props: ['items', 'filter'],

    created () {
        this.events = this.items;
    },

    methods: {

        async Delete (id) {
		    const response = await axios.post(`/admin/item/delete`, { id: id });
            const key = this.events.findIndex(a => a.id == id);
            this.events.splice(key, 1);
  		    Toast("Item Has Been Deleted");
	    },

        async Restore (id) {
            const response = await axios.post(`/admin/item/restore`, { id: id });
            const key = this.events.findIndex(a => a.id == id);
            this.events.splice(key, 1);
            Toast("Item Has Been Restored");
        }

    }

}
</script>